// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SpecificationConformance
 */
export interface SpecificationConformance {
  /**
   *
   */
  title: string;
  /**
   *
   */
  date: string;
  /**
   *
   */
  link?: string | null;
  /**
   *
   */
  explanation?: string | null;
  /**
   *
   */
  pass: boolean;
}

/**
 * Check if a given object implements the SpecificationConformance interface.
 */
export function instanceOfSpecificationConformance(
  value: object
): value is SpecificationConformance {
  if (!("title" in value) || value["title"] === undefined) return false;
  if (!("date" in value) || value["date"] === undefined) return false;
  if (!("pass" in value) || value["pass"] === undefined) return false;
  return true;
}

export function SpecificationConformanceFromJSON(json: any): SpecificationConformance {
  return SpecificationConformanceFromJSONTyped(json, false);
}

export function SpecificationConformanceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SpecificationConformance {
  if (json == null) {
    return json;
  }
  return {
    title: json["title"],
    date: json["date"],
    link: json["link"] === undefined ? undefined : json["link"] === null ? null : json["link"],
    explanation:
      json["explanation"] === undefined
        ? undefined
        : json["explanation"] === null
        ? null
        : json["explanation"],
    pass: json["pass"],
  };
}

export function SpecificationConformanceToJSON(json: any): SpecificationConformance {
  return SpecificationConformanceToJSONTyped(json, false);
}

export function SpecificationConformanceToJSONTyped(
  value?: SpecificationConformance | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    title: value["title"],
    date: value["date"],
    link: value["link"],
    explanation: value["explanation"],
    pass: value["pass"],
  };
}
